import { isViewportTopState } from "@/atoms/viewportTopState";
import useIntersectionObserver from "goi_common/src/hooks/useIntersectionObserver";
import { useRef } from "react";
import { useSetRecoilState } from "recoil";

export function useViewpostTopObserver() {
  const viewportTopRef = useRef<HTMLDivElement>(null);
  const setIsViewportTop = useSetRecoilState(isViewportTopState);

  useIntersectionObserver({
    root: null,
    target: viewportTopRef,
    onIntersect: () => {
      setIsViewportTop(true);
    },
    onNotIntersect: () => {
      setIsViewportTop(false);
    },
    rootMargin: "50px 0px",
  });
  return { viewportTopRef };
}
